import { instanceApi } from './api'

const urlPadrao = `/v1/pedidos`

export const getPedidos = () => instanceApi.get( `${urlPadrao}` )

export const getDadosPedido = ( idPedido ) => instanceApi.get( `${urlPadrao}/${idPedido}` )
